import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/pdpReducer';
import { IPdp } from 'store/types/pdpTypes';

const initialState: IPdp = {
  productTemplate: null,
  factsWindowData: {
    brandProducts: [],
    silhouetteProducts: [],
    categoryProducts: [],
    isCategoryAndFacetMatching: false,
  },
  featuredInCollections: [],
  buyBarVariants: {
    allSizes: [],
    availableSizes: [],
    usedAvailableSizes: [],
    newAvailableSizes: [],
    mapSizeToVariants: {},
  },
  userWants: [],
  experimentsMap: null,
};

export const pdpSlice = createSlice({
  name: 'pdp',
  initialState,
  reducers,
});

export const { setBuyBarVariants, setProductTemplateData, setUserWants, setExperimentsMap } =
  pdpSlice.actions;
export default pdpSlice.reducer;
